import React, { useState } from "react";
import "./ContactMePart.css";
import { getCustomElementUrl, getCompanyPictureUrl } from "../../utils/cloudinary";
import { sendEmail } from "../../api/contact";

import { zoomies, waveform } from "ldrs";

// Cloudinary URLs for images
const whiteArrow = getCustomElementUrl('white_arrow_to_be_used_on_buttons');
const checkMark = getCustomElementUrl('checkmark');
const optimus_hand = getCompanyPictureUrl('tesla_19');
const contact_us_element = getCustomElementUrl('contact_us_element');

const ContactMePart = () => {
    zoomies.register();
    waveform.register();
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [question, setQuestion] = useState("");
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const validateForm = () => {
        if (!name.trim() || !email.trim() || !question.trim()) {
            setIsError(true);
            setErrorMessage("Invalid data, please try again");
            return false;
        }
        // Basic email validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            setIsError(true);
            setErrorMessage("Invalid data, please try again");
            return false;
        }
        return true;
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setIsError(false);
        setErrorMessage("");

        if (!validateForm()) {
            // Reset error state after 3 seconds
            setTimeout(() => {
                setIsError(false);
                setErrorMessage("");
            }, 3000);
            return;
        }

        setIsLoading(true);

        try {
            await sendEmail({
                name,
                email,
                question,
            });

            setIsSubmitted(true);
            setIsLoading(false);

            // Reset form
            setName("");
            setEmail("");
            setQuestion("");

            // Reset the submit-button after 3 seconds
            setTimeout(() => {
                setIsSubmitted(false);
            }, 3000);
        } catch (error) {
            console.error("Failed to send email:", error);
            setIsLoading(false);
            setIsError(true);

            // Display a more specific error message if available
            if (error instanceof Error) {
                if (error.message.includes("timed out")) {
                    setErrorMessage("Request timed out");
                } else {
                    setErrorMessage("Failed to send message");
                }
            } else {
                setErrorMessage("Failed to send message");
            }

            // Reset error state after 3 seconds
            setTimeout(() => {
                setIsError(false);
                setErrorMessage("");
            }, 3000);
        }
    };

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    return (
        <div className="contact-me-part-container">
            <div className="contact-me-content-container">
                <div className="contact-me-contact-box">
                    <div className="contact-me-box-left-container">
                        <div className="contact-me-box-left-container-title">
                            CONTACT ME
                        </div>
                        <form onSubmit={handleSubmit}>
                            <div className="contact-me-box-left-container-name-and-email">
                                <div className="name-field">
                                    <input
                                        type="text"
                                        placeholder="Full name"
                                        value={name}
                                        onChange={(e) =>
                                            setName(e.target.value)
                                        }
                                        className="name-field-input"
                                    />
                                </div>
                                <div className="email-field">
                                    <input
                                        type="email"
                                        placeholder="E-mail"
                                        value={email}
                                        onChange={(e) =>
                                            setEmail(e.target.value)
                                        }
                                        className="email-field-input"
                                    />
                                </div>
                            </div>
                            <div className="contact-me-box-left-container-question-box">
                                <textarea
                                    placeholder="Your question"
                                    value={question}
                                    onChange={(e) =>
                                        setQuestion(e.target.value)
                                    }
                                    className="question-box-textarea"
                                />
                            </div>
                            <div className="contact-me-box-left-container-submit-button">
                                <button
                                    type="submit"
                                    className={`submit-button ${
                                        isSubmitted ? "submitted" : ""
                                    } ${isError ? "error" : ""}`}
                                >
                                    <div
                                        className={`submit-button-content-container ${
                                            isSubmitted
                                                ? "submitted-content-container"
                                                : ""
                                        }`}
                                    >
                                        {isLoading ? (
                                            <div className="submit-button-loading-container">
                                                <l-waveform
                                                    size={
                                                        isLoading ? "25" : "0"
                                                    }
                                                    stroke="3.5"
                                                    speed="1"
                                                    color="white"
                                                ></l-waveform>
                                            </div>
                                        ) : (
                                            <>
                                                <span className="submit-button-text">
                                                    {isError
                                                        ? errorMessage
                                                        : isSubmitted
                                                        ? "Request Sent"
                                                        : "Submit"}
                                                </span>
                                                <div>
                                                    <img
                                                        src={whiteArrow}
                                                        alt="arrow"
                                                        className={`icon-contact-me arrow-icon-contact-me ${
                                                            isSubmitted ||
                                                            isLoading ||
                                                            isError
                                                                ? "hidden"
                                                                : ""
                                                        }`}
                                                    />
                                                    <img
                                                        src={checkMark}
                                                        alt="check-mark"
                                                        className={`icon-contact-me checkmark-contact-me ${
                                                            isSubmitted
                                                                ? ""
                                                                : "hidden"
                                                        }`}
                                                    />
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </button>
                            </div>
                        </form>
                    </div>
                    <div className="contact-me-box-right-container" style={{ backgroundImage: `url(${contact_us_element})` }}>
                        <div className="contact-me-box-right-container-image-container">
                            <img
                                src={optimus_hand}
                                alt="contact-me"
                                className="contact-me-box-right-container-image"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div
                className="contact-me-part-back-to-top-button"
                onClick={scrollToTop}
            >
                <p className="contact-me-part-back-to-top-button-text">
                    Back to top
                </p>
                <img
                    src={whiteArrow}
                    alt="arrow"
                    className="arrow-icon-back-to-top-button"
                />
            </div>
        </div>
    );
};

export default ContactMePart;
